import { useMemo } from "react"
import { useSelector } from "react-redux"

const usePermissions = key => {
  const { userRole } = useSelector(state => state.RolesAndPermissions)
  const { userType } = useSelector(state => state.Login)

  const getCurrentScreenPermissions = (permissions, key) => {
    return permissions[key]
  }

  const permissions = useMemo(() => {
    if (!userRole) return []
    if (
      Array.isArray(userRole.permissions) &&
      userRole.permissions.length === 0
    )
      return []
    return getCurrentScreenPermissions(userRole.permissions, key) || []
  }, [userRole])

  const showAll = useMemo(() => {
    if (!userType || !userRole) {
      return true
    }
    if (userRole?.has_full_permssion) {
      return true
    }

    return userType === "superadmin"
  }, [userType, userRole])

  const jobIds = useMemo(() => {
    if (!userRole) return []

    return getCurrentScreenPermissions(userRole.permissions, "job_ids")
  }, [userRole])

  return { permissions, showAll, jobIds }
}

export default usePermissions
